import * as React from 'react';
import { ThemeContext } from 'styled-components';

import { useFilterContext } from '../../contexts/FiltersContext';
import Filter, { FilterAttributeKey } from '../../models/Filter';
import { AppTheme } from '../../theme/Themes';
import FilterChip from './FilterChip';

const getFilterIcon = (filter: Filter, theme: AppTheme) => {
  if (
    filter?.attributeKey === FilterAttributeKey.TRANSMISSION ||
    filter?.attributeKey === FilterAttributeKey.SAVEDLISTING
  ) {
    return filter.getIcon({
      fill: theme.colors.main.c600,
    });
  }
  return filter.getIcon();
};

type FilterChipProps = {
  filter: Filter;
  text: string;
  onRemove?: () => void;
};

const BaseFilterChip = ({ filter, onRemove, text }: FilterChipProps) => {
  // Dependencies
  const { handleRemoveFilter } = useFilterContext();
  const theme = React.useContext<AppTheme>(ThemeContext);

  // Handlers
  const handleOnClose = () => {
    onRemove ? onRemove?.() : handleRemoveFilter(filter);
  };

  return <FilterChip icon={getFilterIcon(filter, theme)} text={text} onClose={handleOnClose} />;
};

export default BaseFilterChip;
